@if(allowanceEntity$ | async) {
  <form [formGroup]="formGroup" (change)="saveForm()">
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenZorgtoeslag"
                                      id="alOntvangenZorgtoeslag"
                                      label="Voorschot zorgtoeslag"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenKGB"
                                      id="alOntvangenKGB"
                                      label="Voorschot kindgebonden budget"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenKOT"
                                      id="alOntvangenKOT"
                                      label="Voorschot kinderopvangtoeslag"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenHuurtoeslag"
                                      id="alOntvangenHuurtoeslag"
                                      label="Voorschot huurtoeslag"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </form>
}

